import moment from 'moment';

class LadderTime
{
	constructor(){
		this.requestsSent = new Set();
		this.requestsCompleted = [];
	}


	sentRequest(){
		const request = new TimeRequest();
		this.requestsSent.add(request);
		return request;
	}

	requestUpdated(request)
	{
		if(!this.requestsSent.has(request))
		{
			console.error('Weird, this request does not exist anymore');
			return;
		}
		this.requestsSent.delete(request);
		this.requestsCompleted.push(request.difference);
		while(this.requestsCompleted.length > 15)
		{
			this.requestsCompleted.shift();
		}
	}

	getEstimatedServerTime(){
		let averageDifference = 0;
		const requestsToUse = this.filterOutliers();
		if(requestsToUse.length)
		{
			for(let request of requestsToUse)
			{
				averageDifference += request;
			}
			averageDifference = averageDifference / requestsToUse.length;
		}
		return moment.unix(TimeRequest.getNowInSeconds() - averageDifference);
	}

	filterOutliers() {

		const someArray = this.requestsCompleted;
		if(someArray.length < 4)
			return someArray;

		let values, q1, q3, iqr, maxValue, minValue;

		values = someArray.slice().sort( (a, b) => a - b);//copy array fast and sort

		if((values.length / 4) % 1 === 0){//find quartiles
			q1 = 1/2 * (values[(values.length / 4) - 1] + values[(values.length / 4)]);
			q3 = 1/2 * (values[(values.length * (3 / 4)) - 1] + values[(values.length * (3 / 4))]);
		} else {
			q1 = values[Math.floor(values.length / 4)];
			q3 = values[Math.floor(values.length * (3 / 4))];
		}

		iqr = q3 - q1;
		maxValue = q3 + iqr * 1.5;
		minValue = q1 - iqr * 1.5;

		return values.filter((x) => (x >= minValue) && (x <= maxValue));
	}
}

class TimeRequest
{
	constructor(id){
		this.sent = TimeRequest.getNowInSeconds();
		this.answered = null;
		this.serverTimestampInSeconds = null;
		this.totalTripTime = null;

		this.isProbablySynced = null;
	}

	static getNowInSeconds(){
		return Math.floor(Date.now() / 1000);
	}

	gotServerTimestamp(serverTimestampInSeconds){
		this.answered = TimeRequest.getNowInSeconds();
		this.serverTimestampInSeconds = serverTimestampInSeconds; //PHP Server is gonna return timestamp in seconds instead of microseconds

		this.difference = this.answered - this.serverTimestampInSeconds;
		this.totalTripTime = this.answered - this.sent;

		ladderTime.requestUpdated(this);
	}
}
const ladderTime = new LadderTime();
export {ladderTime as LadderTime};